module.exports = __webpack_public_path__ + "img/guangzhanduIcon.0a4fb347.png";